import { render, staticRenderFns } from "./customerLifecycle.vue?vue&type=template&id=e25e47a8"
import script from "./customerLifecycle.vue?vue&type=script&lang=js"
export * from "./customerLifecycle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports